export const SEE_CHANGES_MODAL_ID = "seeChangesModal";
export const SEE_CHANGES_MODAL_WIDTH = "650px";
